import Swiper from "swiper";

function updateOpacity(swiper) {
  // swiper.slides.forEach((slide) => {
  //   const card = slide.querySelector("product-card");
  //   if (!card) return;

  //   const visible = Math.abs(slide.progress) <= 1;

  //   card.style.opacity = visible ? "1" : "0";
  //   card.style.pointerEvents = visible ? "auto" : "none";
  // });
}

document.querySelectorAll("featured-collections-carousel").forEach((el) => {
  const swiper = el.querySelector(".featured-collections-swiper");
  if (!swiper) return;

  const swiperInstance = new Swiper(swiper, {
    effect: "coverflow",
    loop: true,
    centeredSlides: true,
    slidesPerView: 2,        // ← always 3 visible
    spaceBetween: 16,
    watchSlidesProgress: true,

    coverflowEffect: {
      rotate: 0,
      scale: 0.8,
      stretch: 0,
      depth: 0,
      modifier: 1,
      slideShadows: false,
    },

    on: {
      slideNextTransitionStart(swiper) {
        swiper.el.classList.remove("lock");
      },
      slidePrevTransitionStart(swiper) {
        swiper.el.classList.remove("lock");
      },
      progress(swiper) {
        updateOpacity(swiper);
      },
    },

    navigation: {
      prevEl: el.querySelector("[data-carousel-prev]"),
      nextEl: el.querySelector("[data-carousel-next]"),
    },

    breakpoints: {
      700: {
        centeredSlides: false,
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
  });


  const wrapper = swiper.closest('.featured-collections-carousel');
  if (wrapper) {
    const setFigureCenter = (reveal = false) => {
      const figure = wrapper.querySelector('.swiper-slide:not(.swiper-slide-duplicate) .product-card__figure');
      if (!figure) return;

      let offsetTop = 0;
      let el = figure;
      while (el && el !== wrapper) {
        offsetTop += el.offsetTop;
        el = el.offsetParent;
      }
      const center = offsetTop + figure.offsetHeight / 2;
      wrapper.style.setProperty('--figure-center', center + 'px');
      if (reveal) wrapper.classList.add('is-ready');
    };

    const img = wrapper.querySelector('.swiper-slide:not(.swiper-slide-duplicate) .product-card__figure img');
    if (img && !img.complete) {
      img.addEventListener('load', () => requestAnimationFrame(() => setFigureCenter(true)), { once: true });
    } else {
      requestAnimationFrame(() => setFigureCenter(true));
    }

    new ResizeObserver(() => requestAnimationFrame(() => setFigureCenter(true))).observe(wrapper);
  }

});